import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from "app/shared/services/auth/auth.service";
import notify from 'devextreme/ui/notify';


@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }


  ngOnInit() {
  }


  logout() {
    this.authService.logout();
     notify("Successfully logged out", "success", 3000);
    this.router.navigate(["/login"]);

  }
}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/layouts/full-layout.component.ts